'use client';

import React, { PropsWithChildren, useState } from 'react';
import zustandCreate, { StateCreator, StoreApi, UseBoundStore } from 'zustand';

export function createContext<StateType extends object>(
  creator: StateCreator<StateType>,
) {
  const ctx = React.createContext<UseBoundStore<StoreApi<StateType>>>(null);
  function Provider(props: PropsWithChildren<{}>) {
    const [useStore] = useState(() => zustandCreate(creator));
    return <ctx.Provider value={useStore} {...props} />;
  }
  return [ctx, Provider] as const;
}
